<template>
  <div class="guest">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Guest"
};
</script>

<style lang="scss" scoped>
.guest {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
